import { formatScore } from '../AnalysisLayout/analysis.utils';

/** Felles utseende for grafene over snitt per måling (skala 0–5) */
export const yAxisTicks = [0, 1, 2, 3, 4, 5];

/** Bare vannrette, stiplede linjer */
export const chartGridProps = {
  vertical: false,
  strokeDasharray: '4 4',
  stroke: 'var(--ds-color-neutral-border-subtle)',
};

/** Aksene uten streker, bare dempede etiketter */
export const chartAxisProps = {
  axisLine: false,
  tickLine: false,
  stroke: 'var(--ds-color-neutral-text-subtle)',
  fontSize: 12,
};

export const formatChartValue = (value: unknown) =>
  typeof value === 'number' ? formatScore(value, 2) : String(value ?? '');
